<template>
  <Card v-if="loaded" :padding="0">
    <p slot="title">Учреждения</p>
    <a v-if="admin" slot="extra" v-on:click="handleAdd">Добавить</a>
    <Modal
      :mask-closable="false"
      title="Учреждение"
      v-model="modal"
      :loading="saving"
      v-on:on-ok="handleSave"
      v-on:on-visible-change="handleVisibleChange"
    >
      <Form ref="form" :model="model" :rules="rules">
        <FormItem label="Наименование" prop="name">
          <Input v-model="model.name"/>
        </FormItem>
        <FormItem label="Email администратора" prop="admin">
          <Input type="email" v-model="model.admin"/>
        </FormItem>
      </Form>
    </Modal>
    <div class="element" v-for="(element, index) in institutions" :key="element.id">
      <div class="info">
        <p>
          <b>{{ element.name }}</b>
        </p>
        <p>{{ element.admin }}</p>
      </div>
      <div>
        <div class="icons-container">
          <Icon
            class="icon"
            type="md-create"
            size="20"
            v-on:click="() => handleEdit(element, index)"
          />
          <Icon
            class="icon"
            type="md-trash"
            size="20"
            v-on:click="() => handleDelete(element, index)"
          />
        </div>
        <i-switch
          class="switch"
          v-model="element.active"
          v-on:on-change="value => handleActive(element, value)"
        />
      </div>
    </div>
  </Card>
  <Spin v-else size="large" fix/>
</template>

<script>
// TODO EDIT, DELETE INSTITUTION
// TODO CKECK EMAIL ALREADY EXIST
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

import CryptoJS from "crypto-js";

import config from "../../config";
import { constants } from "crypto";

export default {
  data() {
    return {
      id: null,
      admin: false,
      loaded: false,
      modal: false,
      saving: true,
      email: null,
      password: null,
      model: {
        name: null,
        admin: null
      },
      rules: {
        name: [{ required: true, message: " ", pattern: /([^\s])/ }],
        admin: [{ required: true, message: " ", pattern: /([^\s])/ }]
      },
      institutions: []
    };
  },
  async mounted() {
    firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        const admin = (await firebase
          .database()
          .ref(`admin`)
          .once("value")).val();

        if (admin === user.email) {
          this.admin = true;

          const cryptedEmail = window.localStorage.getItem("cryptedEmail");
          const cryptedPassword = window.localStorage.getItem(
            "cryptedPassword"
          );

          this.email = CryptoJS.AES.decrypt(cryptedEmail, admin).toString(
            CryptoJS.enc.Utf8
          );
          this.password = CryptoJS.AES.decrypt(cryptedPassword, admin).toString(
            CryptoJS.enc.Utf8
          );

          const ref = firebase.database().ref("institutions");
          const snapshot = await ref.once("value");
          const array = [];

          snapshot.forEach(childSnapshot => {
            const element = childSnapshot.val();
            element.id = childSnapshot.key;
            array.push(element);
          });

          this.institutions = array;
        } else {
          this.$router.push("/");
        }
      } else {
        this.$router.push("/auth");
      }

      this.loaded = true;
    });
  },
  methods: {
    handleVisibleChange(value) {
      if (!value) {
        setTimeout(() => {
          this.$refs.form.resetFields();
        }, 300);
      }
    },
    handleAdd() {
      this.modal = true;
    },
    async handleActive(item, value) {
      const ref = firebase.database().ref(`institutions/${item.id}`);

      const data = {
        active: value
      };

      await ref.update(data);
    },
    handleEdit(item, index) {
      this.id = item.id;

      this.model = {
        name: item.name,
        admin: item.admin
      };

      this.modal = true;
    },
    async handleDelete(item, index) {
      this.$Modal.confirm({
        title: "Удаление",
        content: "Вы уверены, что хотите удалить?",
        loading: true,
        onOk: async () => {
          try {
            const ref = firebase
              .database()
              .ref(`admissions`)
              .orderByChild("institution")
              .equalTo(item.id);
            const snapshot = await ref.once("value");
            const array = [];

            snapshot.forEach(childSnapshot => {
              array.push(childSnapshot.key);
            });

            for (let i = 0; i < array.length; i++) {
              const element = array[i];

              const path = `admissions/${element}`;
              await firebase
                .database()
                .ref(path)
                .remove();
            }
          } catch (error) {
            console.log(error);
          }

          try {
            const path = `institutions/${item.id}`;
            await firebase
              .database()
              .ref(path)
              .remove();
          } catch (error) {
            console.log(error);
          }

          this.institutions.splice(index, 1);

          this.$Modal.remove();
        }
      });
    },
    async handleSave() {
      const valid = await new Promise(resolve =>
        this.$refs.form.validate(valid => resolve(valid))
      );

      if (!valid) {
        this.$Message.error("Необходимо заполнить поля");
        this.saving = false;
        await this.$nextTick();
        this.saving = true;
        return;
      }

      await this.save();
    },
    async save() {
      const path = `institutions/${this.id}/admin`;
      const ref = firebase.database().ref(path);
      const adminData = await ref.once("value");
      const admin = adminData.val();

      if (this.model.admin !== admin) {
        const auth = firebase.auth();

        const actionCodeSettings = {
          url: config.url,
          handleCodeInApp: false
        };

        auth.languageCode = "ru";

        try {
          const value = await auth.createUserWithEmailAndPassword(
            this.model.admin,
            "univer555"
          );

          await auth.sendPasswordResetEmail(
            this.model.admin,
            actionCodeSettings
          );
        } catch (error) {
          if (error.code === "auth/email-already-in-use") {
            await auth.sendPasswordResetEmail(
              this.model.admin,
              actionCodeSettings
            );
          }

          console.log(error);
        }

        await firebase.auth().signOut();

        await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password);
      }

      try {
        const ref = !!this.id
          ? firebase.database().ref(`institutions/${this.id}`)
          : firebase
              .database()
              .ref(`institutions`)
              .push();

        const data = {
          name: this.model.name,
          admin: this.model.admin.toLowerCase()
        };

        await ref.update(data);

        data.id = ref.key;

        if (this.id) {
          const index = this.institutions.findIndex(e => e.id === this.id);
          this.$set(this.institutions, index, data);
          this.id = null;
        } else {
          this.institutions.push(data);
        }

        if (this.$refs.form) this.$refs.form.resetFields();

        this.$Message.success("Успешно сохранено");

        this.modal = false;
      } catch (error) {
        console.log(error);

        this.$Message.error("Ошибка");

        this.saving = false;
        await this.$nextTick();
        this.saving = true;
      }
    }
  }
};
</script>

<style scoped>
.root {
  width: 100%;
  height: 100%;
}
.element {
  padding: 16px;
  border-bottom: 1px solid #e8eaec;
}
.element {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.icons-container {
  min-width: 56px;
}
.icon {
  cursor: pointer;
  margin: 4px;
}
.switch {
  margin: 4px;
}
</style>